<template>
  <div class="cata-item">
    <div
      v-if="cata.children"
      class="cata-body folder"
      :style="{
        paddingLeft: padding + 'px',
      }"
      :class="{
        active: containActive,
      }"
      @click="unfold = !unfold"
    >
      <img
        :style="{
          transform: unfold ? 'rotate(90deg)' : '',
        }"
        class="arrow"
        src="@/assets/icon/arrow.png"
        alt=""
      />
      <div class="title-text">{{ cata.name }}</div>
    </div>
    <div
      :class="{
        active: catalog.activeCata === this.cata,
      }"
      :style="{
        paddingLeft: padding + 'px',
      }"
      @click="articleClick"
      v-else
      class="cata-body article"
    >
      <div class="article-name">
        <div class="article-text">{{ cata.name }}</div>
      </div>
    </div>
    <template v-if="cata.children && unfold">
      <cata-item
        v-for="(item, index) in cata.children"
        :cata="item"
        :key="index"
        :padding="padding + 20"
      ></cata-item>
    </template>
  </div>
</template>

<script>
import Bus from './bus'
export default {
  name: 'CataItem',
  props: {
    cata: Object,
    padding: {
      default: 8
    }
  },
  data() {
    return {
      unfold: false
    }
  },
  inject: ['catalog'],
  computed: {
    containActive() {
      let active = this.catalog.activeCata
      let isContain = cata => {
        if (cata === active) {
          this.unfold = true
          return true
        }
        if (!cata.children) {
          this.unfold = false
          return false
        }
        let contain = false
        for (let i = 0; i < cata.children.length; i++) {
          if (isContain(cata.children[i])) {
            this.unfold = true
            contain = true
          }
        }
        this.unfold = contain
        return contain
      }
      return isContain(this.cata)
    }
  },
  methods: {
    articleClick() {
      Bus.$emit('cata-click', this.cata)
    }
  },
}
</script>

<style lang="scss" scoped>
.cata-item {
  overflow: hidden;
}
.cata-body {
  user-select: none;
  display: flex;
  align-items: center;
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #505050;
  line-height: 14px;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  &:hover {
    background-color: rgba($color: #00a1d6, $alpha: 0.05);
  }
  &.article.active {
    color: #00a1d6;
    background-color: rgba($color: #00a1d6, $alpha: 0.1);
  }
  &.folder {
    font-weight: bold;
  }
  &.folder.active {
    color: #00a1d6;
  }
}
.title-text {
  line-height: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  box-sizing: border-box;
  padding-right: 10px;
}
.article-text {
  line-height: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  box-sizing: border-box;
  padding-right: 5px;
}
.article-name {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 2px;
    height: 2px;
    border-radius: 1px;
    left: -12px;
    top: 19px;
    background-color: #aaa;
  }
}

.arrow {
  width: 18px;
  margin-right: 2px;
  position: relative;
  left: -5px;
  transition: transform 0.1s ease-in-out;
}
</style>